<template>
  <div class="contact-form">
    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.is') }}</option>
      <option :value='false'>{{ $t('root.filters.is_not') }}</option>
    </select>

    <label>{{ $t('root.filters.folder_name') }}</label>
    <multi-select :template='folderTemplate' :getter='getFolders' v-model='selectedFolders' />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  import _multi_select from '../../_infinite_multi_select'

  export default {
    components: {
      'multi-select': _multi_select,
    },
    props: {
      folder: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        predicate: true,
        selectedFolders: [],
      }
    },
    computed: {
      selectedFolderIds() {
        return this.selectedFolders.map(c => c.id)
      },
      predicateQuery() {
        return this.predicate ? 'filters[breadcrumbs_jcont]' : 'filters[breadcrumbs_not_jcont]'
      }
    },
    methods: {
      filter() {
        let newQuery = Object.assign({}, this.query)

        delete newQuery['filters[breadcrumbs_jcont]']
        delete newQuery['filters[breadcrumbs_not_jcont]']

        newQuery = Object.assign({}, newQuery, { page: 1, parent_id: this.folder.id, [this.predicateQuery]: this.selectedFolderIds })

        this.$router.push({ query: newQuery })
      },
      getFolders(params) {
        return this.listStore.getFolders(Object.assign({ parent_id: this.folder.id }, params))
      },
    }
  }
</script>

<style lang="sass" scoped>
.contact-form
  width: 325px
  padding: 10px
  select
    margin-bottom: 15px
  .custom-select
    margin-bottom: 15px
.form-inline
  label
    margin-right: 10px
    &:first-child
      margin-right: 15px
  input
    margin-left: 3px
</style>
